'use client';
import Link from 'next/link';

const ServiceHeader = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <div className="inline-block px-4 py-2 bg-[#29abe2] bg-opacity-10 rounded-full mb-4">
                        <span className="text-[#29abe2] font-semibold">Our Services</span>
                    </div>
                    <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                        Comprehensive Logistics Solutions
                    </h1>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
                        National capacity via own assets & collaboration with trusted partners. 
                        A network you can trust of over 300 power units and 1,500 chassis via JCT.
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <div className="bg-white px-6 py-4 rounded-lg shadow-sm">
                            <div className="text-[#29abe2] font-semibold">Import & Export</div>
                            <div className="text-gray-700">Drayage execution from both rail and port </div>
                        </div>
                        <div className="bg-white px-6 py-4 rounded-lg shadow-sm">
                            <div className="text-[#29abe2] font-semibold">Destination</div>
                            <div className="text-gray-700">Management </div>
                        </div>
                        <div className="bg-white px-6 py-4 rounded-lg shadow-sm">
                            <div className="text-[#29abe2] font-semibold">Strategic</div>
                            <div className="text-gray-700">Pre-pull, secure storage, and grounding solutions </div>
                        </div>
                        <div className="bg-white px-6 py-4 rounded-lg shadow-sm">
                            <div className="text-[#29abe2] font-semibold">Dedicated</div>
                            <div className="text-gray-700">Yard Operations</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceHeader; 